// extracted by mini-css-extract-plugin
export var activeDot = "_2a-c";
export var buttonContainer = "_2a-9";
export var channelButton = "_2a-a";
export var clickable = "_2a-d";
export var content = "_2a-0";
export var contentFull = "_2a-2";
export var contentThird = "_2a-1";
export var contentWrapper = "_2a-7";
export var description = "_2a-5";
export var heightShort = "_2a-f";
export var image = "_2a-3";
export var imageContainer = "_2a-4";
export var selectButton = "_2a-e";
export var spinnerContainer = "_2a-b";
export var titleContent = "_2a-8";
export var titleWrapper = "_2a-6";